/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import FeatherIcon from 'feather-icons-react';

import { API_URL } from '../../constants/api';
import KaafiPayWeb from './KaafiPay/KaafiPay';
import GalmudugWeb from './galmudug/Galmudug';

const WebRenderer = () => {
  if (API_URL.includes('galmudug')) {
    return <GalmudugWeb />;
  } else {
    return <KaafiPayWeb />;
  }
};

export default WebRenderer;
